import {
  CheckOutlined,
  LoadingOutlined,
  RedoOutlined,
} from "@ant-design/icons";
import { Spin, Tooltip, Button } from "antd";
import { useEffect, useState } from "react";

const antIcon = <LoadingOutlined style={{ fontSize: 20 }} spin />;

type Props = {
  refresh: () => void;
  resetRefreshState: () => void;
  isLoading: boolean;
  success: boolean;
  hintText: string;
};

function RefreshButton({
  refresh,
  isLoading,
  success,
  resetRefreshState,
  hintText,
}: Props) {
  const buttonStyle = "rounded w-8 h-8 flex items-center justify-center shadow";

  useEffect(() => {
    if (success) {
      setTimeout(() => {
        resetRefreshState();
      }, 1000);
    }
  }, [success]);

  let buttonDiv;

  if (success) {
    buttonDiv = (
      <Button className="w-full mb-2" type="dashed">
        <CheckOutlined /> Done!
      </Button>
    );
  } else if (isLoading) {
    buttonDiv = (
      <Button className="w-full mb-2" type="dashed">
        <Spin indicator={antIcon} /> <span className="ml-2">Refreshing...</span>
      </Button>
    );
  } else {
    buttonDiv = (
      <Button className="w-full mb-2" type="dashed" onClick={refresh}>
        <RedoOutlined /> Click to refresh
      </Button>
    );
  }

  return (
    <Tooltip
      placement="left"
      title={hintText} //"Can't find a channel? click here to refresh"
      overlayStyle={{ width: "220px", fontSize: "14px" }}
    >
      {buttonDiv}
    </Tooltip>
  );
}

export default RefreshButton;
